import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Tax } from '../entities/tax.entity';

@Injectable({ providedIn: 'root' })
export class TaxInfrastructure {
  private readonly endpoint = `${environment.apihost}/api/tax`;

  constructor(private _http: HttpClient) {}

  public getTaxData(customerId: string): Observable<Tax[]> {
    return this._http.get<Tax[]>(`${this.endpoint}/${customerId}`);
  }
}
